import type { RootState } from 'store';

export const getUnitInfoData = (state: RootState) =>
  state.unitInfoDataState.unitInfoData;
